import { render } from "./DocSend.vue?vue&type=template&id=a8f09268"
import script from "./DocSend.vue?vue&type=script&lang=js"
export * from "./DocSend.vue?vue&type=script&lang=js"

import "./DocSend.vue?vue&type=style&index=0&id=a8f09268&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__